export type TourSide = 'top' | 'right' | 'bottom' | 'left';

export interface TourStep<Anchor extends string> {
  anchor: Anchor;
  title: string;
  body: string;
  /** Lado preferido de la burbuja. Si no cabe, Radix la voltea. */
  side?: TourSide;
}

export interface TourSpec<Anchor extends string> {
  /** También es el `tour_id` de los eventos y parte de la llave de storage. */
  id: string;
  /** Subirla vuelve a mostrar el tour a quien ya lo vio. */
  version: number;
  steps: readonly TourStep<Anchor>[];
  /**
   * Espera antes de arrancar, contada desde que puede (`enabled`). Deja ver la
   * pantalla antes de la primera burbuja, sobre todo si se acaba de cerrar algo.
   */
  startDelayMs?: number;
}

export const TOUR_ANCHOR_ATTRIBUTE = 'data-tour';

export interface TourAnchorProps {
  'data-tour': string;
}

export interface TourDefinition<Anchor extends string = string> extends TourSpec<Anchor> {
  /**
   * Props del elemento que ancla un paso. Solo acepta los ids que declara el
   * tour: renombrar un paso sin su ancla, o al revés, truena en `tsc` en vez de
   * dejar un paso que nunca aparece.
   */
  anchor(id: Anchor): TourAnchorProps;
}

/**
 * Un tour es DATA: id, versión y pasos. El motor (`useTour` / `TourLayer`) corre
 * cualquiera; agregar uno nuevo no toca el runtime.
 */
export const defineTour = <const Anchor extends string>(
  spec: TourSpec<Anchor>,
): TourDefinition<Anchor> => ({
  ...spec,
  anchor: (id) => ({ [TOUR_ANCHOR_ATTRIBUTE]: id }),
});
